import { theme } from "styles/mui-config";
import styled from "styled-components";
import ImgContainer from "components/shared/Image";
import Typography from "@mui/material/Typography";
import CardContent from "@mui/material/CardContent";

export const StyledImgContainer = styled(ImgContainer)`
  overflow: hidden;
  width: 93%;
  margin: auto;
  border-radius: 5px;
  & img {
    border-radius: 5px;
    height: 100% !important;
    width: auto !important;
  }
`;
export const StyledTypographyContent = styled.pre`
  line-height: 35px !important;
  padding: 10px;
  font-family: inherit;
  color: #414141;
  white-space: pre-wrap;
  white-space: -moz-pre-wrap;
  white-space: -pre-wrap;
  white-space: -o-pre-wrap;
  word-wrap: break-word;
`;
// export const StyledCardContent = styled(CardContent)`
//   color: ${theme.palette.primary.dark};
//   // border-right: 4px solid ${theme.palette.primary.dark};
//   padding: 10px !important;
//   // margin-top: 20px;
//   position: relative;
//   & p {
//     text-align: center;
//     padding-top: 10px;
//   }
//   &::before {
//     content: "";
//     position: absolute;
//     right: 50%;
//     left: 50%;
//     top: 0px;
//     width: 100px;
//     border: 3px solid ${theme.palette.primary.dark};
//     border-radius: 1px;
//     border-bottom-right-radius: 6px;
//     border-bottom-left-radius: 6px;
//     pointer-events: none;
//     transform: translate(50%);
//   }
// `;

export const StyledCardContent = styled(CardContent)`
  color: ${theme.palette.primary.dark};
  // border-right: 4px solid ${theme.palette.primary.dark};
  padding: 10px !important;
  margin-top: 20px;
  position: relative;
  & > p {
    text-align: right;
    padding-right: 5px;
    font-size: 28px;
    font-family: "Avini";
    @media (max-width: 600px) {
      font-size: 21px;
    }
  }
  &::before {
    content: "";
    position: absolute;
    right: 0px;
    top: -5px;
    height: 110%;
    border: 3px solid ${theme.palette.primary.dark};
    border-radius: 1px;
    border-top-left-radius: 6px;
    border-bottom-left-radius: 6px;
    pointer-events: none;
  }
`;

export const StyledCardHeader = styled.div`
  border: 2px solid #e9e9e9;
  color: #808080;
  padding: 4px !important;
  float: left;
  margin-left: 15px;
  margin-bottom: 15px;
  border-radius: 5px;
  font-size: 10px;
  display: flex;
  align-items: center;
  & span {
    margin-right: 5px;
  }
`;
